import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { authApi, authModel } from '@_entities/auth';

import { Bridge } from '@_shared/config';
import { TColorNames } from '@_shared/styles';
import { Button } from '@_shared/ui/Button';
import { Typography } from '@_shared/ui/Typography';

import * as S from './FavoritesSlide.style';

const BUTTON_COLOR: Record<string, TColorNames> = {
	DISABLED: 'warmgray-300',
	ENABLED: 'orange-primary',
};

const MAX_FAVORITES_COUNT = 8;

export function FavoritesSlide({
	submitData,
}: {
	submitData: {
		nickname: string;
		optionalTerms: string[];
		favorites: string[];
	};
}) {
	const navigate = useNavigate();

	const [selectedFavorites, setSelectedFavorites] = useState<string[]>([]);

	function clickFavorite(code: string) {
		const isAlreadySelected = selectedFavorites.includes(code);
		const hasReachedMaxLimit = selectedFavorites.length >= MAX_FAVORITES_COUNT;

		if (isAlreadySelected) {
			setSelectedFavorites((prev) => prev.filter((favoriteCode) => favoriteCode !== code));
		} else if (!hasReachedMaxLimit) {
			setSelectedFavorites((prev) => [...prev, code]);
		}
	}

	return (
		<S.SlideContainer>
			<S.TermsSlide>
				<Typography type="headline-small" color="font-primary">
					{submitData.nickname}
					님의
					<br />
					관심사는 무엇인가요?
					<Typography type="title-medium" color="font-secondary">
						8개까지 선택할 수 있어요 :)
					</Typography>
				</Typography>

				<S.FavoriteList>
					{authModel.FAVORITE_LIST.map((favorite) => (
						<S.FavoriteItem
							key={favorite.code}
							isChecked={selectedFavorites.includes(favorite.code)}
							onClick={() => {
								clickFavorite(favorite.code);
							}}
						>
							<Typography
								type="title-medium"
								color={
									selectedFavorites.includes(favorite.code)
										? 'warmgray-800'
										: 'warmgray-600'
								}
							>
								{favorite.name}
							</Typography>
							<S.FavoriteIcon>{favorite.icon}</S.FavoriteIcon>
						</S.FavoriteItem>
					))}
				</S.FavoriteList>
			</S.TermsSlide>

			<S.BottomButtonContainer>
				<Button
					bgColor={`${selectedFavorites.length < 1 ? BUTTON_COLOR.DISABLED : BUTTON_COLOR.ENABLED}`}
					fullWidth
					disabled={selectedFavorites.length < 1}
					onClick={() => {
						authApi
							.signin({
								...submitData,
								favorites: selectedFavorites,
							})
							.then((response) => {
								localStorage.setItem('access_token', response.data.access);

								new Bridge().postUUID(response.data.userData.uuid);

								navigate('/folder/all', { replace: true });
							});
					}}
				>
					<Typography type="title-large" color="white-primary">
						완료
					</Typography>
				</Button>
			</S.BottomButtonContainer>
		</S.SlideContainer>
	);
}
